import { ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, Subject, takeUntil } from 'rxjs';
import { environment } from '../../../environments/environment';
import { App } from '../../app';
import { NgFor, NgForOf, NgIf } from '@angular/common';
import { SelectedBrandModelService } from '../../service/selected-brand-model.service';
import { Tooltip } from 'primeng/tooltip';
import { ECollection } from '../../enums/ECollection';
import { EReviewsStatus } from '../../enums/EReviewsStatus';
import { EShippingType } from '../../enums/EShippingType';
import { IQueryFormat } from '../../enums/types';
import { IAddToCart } from '../../interfaces/IAddToCart';
import { IBrand, IBrand_P, IBrand_S } from '../../interfaces/IBrand';
import { ICategories_S } from '../../interfaces/ICategories';
import { IDescriptions, IDescriptions_P, IDescriptions_S } from '../../interfaces/IDescriptions';
import { IImgUrlArr } from '../../interfaces/IImgUrlArr';
import { IModel, IModel_P, IModel_S } from '../../interfaces/IModel';
import { IProducts, IProducts_P, IProducts_S } from '../../interfaces/IProducts';
import { IReviews, IReviews_P, IReviews_S } from '../../interfaces/IReviews';
import { ISpecifications, ISpecifications_P, ISpecifications_S } from '../../interfaces/ISpecifications';
import { ISubCategories } from '../../interfaces/ISubCategories';
import { IWishlist, IWishlist_P, IWishlist_S } from '../../interfaces/IWishlist';
import { SafePipe } from '../../pipes/SafePipe.pipe';
import { AddToCartService } from '../../service/add-to-cart.service';
import { AuthService } from '../../service/auth.service';
import { BrandService } from '../../service/brand.service';
import { ConstantsService } from '../../service/constants.service';
import { DescriptionsService } from '../../service/descriptions.service';
import { EventCenterS } from '../../service/event-center.s';
import { ModelService } from '../../service/model.service';
import { NotificationService } from '../../service/notification.service';
import { ProductsService } from '../../service/products.service';
import { ReviewsService } from '../../service/reviews.service';
import { SpecificationsService } from '../../service/specifications.service';
import * as _ from 'lodash';
import { WishlistService } from '../../service/wishlist.service';
import { Select } from 'primeng/select';
import { LocalCartService } from 'src/app/service/local-cart.service';
import { ELocalStorage } from '../../enums/ELocalStorage';
import { UserService } from '../../service/user.service';

declare let moment: any;
declare const $: any;

@Component({
    selector: 'app-phone-case-details',
    standalone: true,
    templateUrl: './phone-case-details.html',
    imports: [ NgForOf, Tooltip, SafePipe, NgIf, FormsModule, Select, NgFor ],
    styleUrl: 'phone-case-details.scss'
})
export class PhoneCaseDetails implements OnInit, OnDestroy {
    loading = { form: false };
    addingToCart: boolean = false;
    mainImage: string = '';
    images: IImgUrlArr[] = [];
    reviewsRatings: number[] = [];
    colors: any[] = [];
    selectedColor: string = '';
    selectedColorName: string = '';
    brandId: string = '';
    modelId: string = '';
    productId: string = '';
    noDesignForModel: boolean = false;
    product: IProducts = <any>{};
    subCategories: ISubCategories = <any>{};
    descriptions: IDescriptions = <any>{};
    specifications: ISpecifications = <any>{};
    productReviews: IReviews[] = [];
    fileUrl = environment.FILE_URL;
    productsYouMayAlsoLike: IProducts[] = [];
    productsYouMayAlsoLikeGroups: { categoryId: string; category: string; products: IProducts[] }[] = [];
    selectedAlsoLikeCategoryId: string = '';
    brandList: IBrand[] = [];
    modelList: IModel[] = [];
    reviews: IReviews = <any>{};
    isWishListProduct: boolean = false;
    EShippingType = EShippingType;

    currentSlideIndex: number = 0;
    owlCarousel: any;
    $index: any;


    @HostListener('window:scroll', [])
    onWindowScroll() {
        this.app.isScrolled = window.scrollY < 99999;
        this.app.hideTopStrip = window.scrollY < 99999;
    }

    private destroy$ = new Subject<void>();

    constructor(private app: App,
                private cd: ChangeDetectorRef,
                private productsService: ProductsService,
                private descriptionsService: DescriptionsService,
                private specificationsService: SpecificationsService,
                private reviewsService: ReviewsService,
                private addToCartService: AddToCartService,
                private wishlistService: WishlistService,
                private brandService: BrandService,
                private userService: UserService,
                private modelService: ModelService,
                private ns: NotificationService,
                private eventCenterS: EventCenterS,
                private authService: AuthService,
                private cs: ConstantsService,
                private router: Router,
                private route: ActivatedRoute,
                private localCartService: LocalCartService,
                private selectedBrandModelService: SelectedBrandModelService
            ) {
    }

    async ngOnInit() {
        let defaultAMToken: any = await this.userService.getAMToken();
        window.localStorage.setItem(ELocalStorage.DEFAULT_AM_AUTH, defaultAMToken.token);

        this.isWishListProduct = false;
        this.productId = <any>this.route.snapshot.queryParamMap.get('product');

        await this.loadProducts();
        await this.loadProductsRandom();
        await this.loadBrand();
        this.app.isScrolled = true;
        this.app.hideTopStrip = true;

        this.router.events.pipe(filter(event => event instanceof NavigationEnd), takeUntil(this.destroy$)).subscribe(async () => {
            this.destroyCarousel();
            this.productId = <any>this.route.snapshot.queryParamMap.get('product');
            // load the product first so brandId/modelId are fresh before the
            // related list is fetched (it filters on those ids)
            await this.loadProducts();
            await this.loadProductsRandom();
            await this.loadBrand();
            setTimeout(() => {
                this.productCaseSlider();
            }, 1000);

            this.cd.detectChanges();
        });

        // let selectedRating = 0;
        // document.querySelectorAll('.rating-input i').forEach(star => {
        //     star.addEventListener('mouseenter', () => {
        //         // @ts-ignore
        //         const rating = +star.dataset.rating;
        //         this.highlightStars(rating);
        //     });
        //
        //     star.addEventListener('mouseleave', () => {
        //         this.highlightStars(selectedRating);
        //     });
        //
        //     star.addEventListener('click', () => {
        //         // @ts-ignore
        //         selectedRating = +star.dataset.rating;
        //         this.highlightStars(selectedRating);
        //     });
        // });
        // @ts-ignore
        document.getElementById("copyLinkBtn")?.addEventListener("click", function () {
            const url = window.location.href;

            navigator.clipboard.writeText(url).then(() => {
                const feedback = document.getElementById("copyFeedback");
                if (feedback) {
                    feedback.classList.remove("d-none");

                    setTimeout(() => {
                        feedback.classList.add("d-none");
                    }, 2000);
                }
            });
        });

        this.eventCenterS.loadAddWishlistProductDetailsPage.subscribe(async (data: boolean) => {
            if (data) this.getWishlistProduct().then();
        });
        setTimeout(() => {
            this.productCaseSlider();
        }, 1000);
    }

    copyUrl(): void {
        const url = window.location.href;
        const feedback = document.getElementById("copyFeedback");

        navigator.clipboard.writeText(url).then(() => {
            if (feedback) {
                feedback.classList.remove("d-none");

                setTimeout(() => {
                    feedback.classList.add("d-none");
                }, 3000);
            }
        });
    }

    // highlightStars(rating: any) {
    //     document.querySelectorAll('.rating-input i').forEach(star => {
    //         // @ts-ignore
    //         const current = +star.dataset.rating;
    //         star.classList.toggle('active', current <= rating);
    //     });
    // }

    selectColor(color: any) {
        this.selectedColor = color.code;
        this.selectedColorName = color.name;
        this.loadImages(this.selectedColorName);
        this.getWishlistProduct().then();
    }

    prevImage() {
        const currentIndex = this.images.findIndex(image => image.fileUrl === this.mainImage);
        const prevIndex = (currentIndex - 1 + this.images.length) % this.images.length;
        this.mainImage = <any>this.images[prevIndex].fileUrl;
    }

    nextImage() {
        const currentIndex = this.images.findIndex(image => image.fileUrl === this.mainImage);
        const nextIndex = (currentIndex + 1) % this.images.length;
        this.mainImage = <any>this.images[nextIndex].fileUrl;
    }

    async loadProducts() {
        this.loading.form = true;
        this.noDesignForModel = false;
        this.product = <any>{};
        this.product = await this.productsService.getByIdAndDeep(this.productId,
            JSON.stringify(
                [
                    {
                        s_key: 'pro_category_id',
                        deep: [
                            { s_key: 'cat_sub_category_id' }
                        ]
                    },
                    { s_key: 'pro_model_id' },
                    { s_key: 'pro_brand_id' }
                ]
            ));
        // console.log("Products loaded");
        // console.log(this.product);
        this.subCategories = this.product.pro_category_id?.cat_sub_category_id;
        if (this.product.pro_category_id?.cat_product_content_img_url_arr?.length) this.product.pro_category_id.fileUrl = `${ this.fileUrl }${ this.product.pro_category_id.cat_product_content_img_url_arr[0].uploadPath }`;
        // @ts-ignore
        if (this.subCategories?.ssc_img_url__arr?.length) this.subCategories.fileUrl = `${ this.fileUrl }${ this.subCategories.ssc_img_url__arr[0].uploadPath }`;
        this.colors = [];
        this.brandId = <any>this.product.pro_brand_id?._id;
        this.modelId = <any>this.product.pro_model_id?._id;
        for (let item of this.product.pro_images_arr || []) item.fileUrl = `${ this.fileUrl }${ item.uploadPath }`;
        // the Add-to-Cart button is gated on brandId/modelId (see canAddToCart); flush change
        // detection here so it becomes clickable as soon as the product itself is known,
        // instead of staying disabled until the secondary requests below have all finished.
        this.loadImages('');
        this.loading.form = false;
        this.cd.detectChanges();
        // for (let item of this.product.pro_images_color_arr || []) {
        //     for (let i of item.pro_template_arr || []) i.fileUrl = `${this.fileUrl}${i.uploadPath}`;
        //     let obj = <any>{};
        //     if (item.color === EColor.Black) {
        //         obj.name = item.color;
        //         obj.code = '#000000';
        //     } else if (item.color === EColor.White) {
        //         obj.name = item.color;
        //         obj.code = '#f1f1f1';
        //     }
        //     if (item.color) {
        //         this.colors.push(obj);
        //         this.selectColor(this.colors[0]);
        //     }
        // }
        // none of these gate Add-to-Cart, and none of them own error handling of their own —
        // let one failing leave the rest of the page usable instead of killing the load.
        try {
            await Promise.all([
                this.loadProductsDescriptions(),
                this.loadProductsSpecifications(),
                this.loadProductsReview(),
                this.getWishlistProduct()
            ]);
        } catch (e: any) {
            console.error(e);
        } finally {
            this.loading.form = false;
        }
        this.cd.detectChanges();
    }

    loadImages(colorName: string) {
        this.images = [];
        // let findObj = <any>this.product.pro_images_arr?.find(e => e.color === colorName);
        this.images = this.product.pro_images_arr || [];
        // this.images = findObj.pro_template_arr || [];
        if (this.images.length) this.clickImages(this.images[0]);
        else this.mainImage = '';
        this.$index = this.images.map(i => {
            return this.images.indexOf(i);
        });
    }

    clickImages(img: IImgUrlArr) {
        this.mainImage = <any>img?.fileUrl || '';
    }

    async loadProductsDescriptions() {
        this.loading.form = true;
        this.descriptions = <any>{};
        let query = <IQueryFormat>{
            find: <IDescriptions_P>{
                active: true,
                swd_product_id_arr: this.productId
            },
            select: <IDescriptions_S>{ swd_descriptions_str: 1 },
            sort: <IDescriptions_S>{ createdAt: -1 },
            limit: 1
        };
        let resp = await this.descriptionsService.query(query);
        if (resp && resp.length) this.descriptions = resp[0];
        this.loading.form = false;
        this.cd.detectChanges();
    }

    async loadProductsSpecifications() {
        this.loading.form = true;
        this.specifications = <any>{};
        let query = <IQueryFormat>{
            find: <ISpecifications_P>{
                active: true,
                sws_product_id_arr: this.productId
            },
            select: <ISpecifications_S>{ sws_descriptions_str: 1 },
            sort: <IDescriptions_S>{ createdAt: -1 },
            limit: 1
        };
        let resp = await this.specificationsService.query(query);
        if (resp && resp.length) this.specifications = resp[0];
        this.loading.form = false;
        this.cd.detectChanges();
    }

    async loadBrand() {
        this.loading.form = true;
        this.brandList = [];
        this.modelList = [];
        let query = <IQueryFormat>{
            find: <IBrand_P>{
                active: true,
            },
            select: <IBrand_S>{ swb_name_str: 1 },
            sort: <IBrand_S>{ swb_name_str: 1 },
        };
        this.brandList = await this.brandService.query(query);
        if (this.brandId) await this.loadModels();
        this.loading.form = false;
        this.cd.detectChanges();
    }

    async loadModels() {
        this.loading.form = true;
        this.modelList = [];
        let query = <IQueryFormat>{
            find: <IModel_P>{
                active: true,
                swm_brand_id: this.brandId,
            },
            select: <IModel_S>{ swm_name_str: 1 },
            sort: <IModel_S>{ swm_name_str: 1 },
        };
        this.modelList = await this.modelService.query(query);
        this.loading.form = false;
        this.cd.detectChanges();
    }

    async findProduct(): Promise<boolean> {
        if (this.brandId && this.modelId) {
            // Product names embed the model name (e.g. "... for iPhone 14 with ..."), so a variant
            // for a different model never shares the exact same pro_name_str. Substitute the old
            // model's name for the new one to land on the name the target variant actually has.
            const oldModelName = this.product.pro_model_id?.swm_name_str;
            const newModelName = this.modelList.find((m: any) => m._id === this.modelId)?.swm_name_str;
            const expectedName = (oldModelName && newModelName)
                ? this.product.pro_name_str.replace(oldModelName, newModelName)
                : this.product.pro_name_str;
            let query = <IQueryFormat>{
                find: <IProducts_P>{
                    active: true,
                    pro_name_str: expectedName,
                    pro_brand_id: <any>this.brandId,
                    pro_model_id: <any>this.modelId
                },
                select: <IProducts_S>{ pro_name_str: 1 },
            };
            let resp = await this.productsService.query(query);
            if (resp && resp.length) {
                this.openDetailsPage(resp[0]);
                return true;
            }
            this.loading.form = false;
            this.cd.detectChanges();
        }
        return false;
    }

    async loadProductsReview() {
        this.loading.form = true;
        this.productReviews = [];
        this.reviewsRatings = [];
        let resp = await this.reviewsService.getReviews({ productId: this.productId });
        if (resp && resp.length) {
            for (let item of resp) {
                item.createdAt = `${ moment(item.createdAt).format('MMMM') } ${ moment(item.createdAt).format('DD') }, ${ moment(item.createdAt).format('YYYY') }`;
                item.ratings = Array.from({ length: Number(item.swr_rating_str) }, (_, i) => i + 1); // [1, 2, 3, 4, 5]
            }
            this.productReviews = resp;
            let ratingSum = _.sumBy(resp, (item: any) => Number(item.swr_rating_str));
            let ratingCount = Math.floor(ratingSum / this.productReviews.length);
            this.reviewsRatings = Array.from({ length: ratingCount }, (_, i) => i + 1);
        }
        this.loading.form = false;
        this.cd.detectChanges();
    }

    async submitReview() {
        const formData: IReviews = this.reviews;
        formData.active = true;
        formData.createdAt = new Date();
        formData.swr_user_id = <any>this.authService.gUser?._id;
        formData.swr_status_str = EReviewsStatus.PENDING;
        formData.swr_product_id = this.productId;

        // if (!formData.swr_desc_str) return this.ns.showError('Please enter review.');
        if (!formData.swr_rating_str) return this.ns.showError('Please select rating.');
        if (!formData.swr_user_id) return this.eventCenterS.shoLoginDialog.next(true);

        try {
            this.loading.form = true;
            let res = await this.reviewsService.post(formData);
            if (res) {
                this.ns.showSuccess(this.cs.review.success);
                this.reviews = <any>{};
            }
            this.loading.form = false;
        } catch (e: any) {
            this.loading.form = false;
            this.ns.showErrorFromResponse(e.error || e, 'Failed to submit review.');
        }
        this.cd.detectChanges();
    }

    async addToCartProduct() {
        // every other exit below reports itself with a toast; these two are the only silent ones,
        // so keep them narrow — `loading.form` is the shared page-load flag and must not be used
        // here, or one failed background request would mute the button for good.
        if (this.addingToCart) return;
        if (!this.canAddToCart) return this.ns.showError('Please wait, the product is still loading.');
        const formData: IAddToCart = <any>{};
        formData.active = true;
        formData.createdAt = new Date();
        formData.atc_product_id = <any>this.productId;
        formData.atc_user_id = <any>this.authService.gUser?._id;
        formData.atc_model_id = <any>this.modelId || '';
        formData.atc_brand_id = <any>this.brandId || '';
        formData.atc_color_str = this.selectedColorName || '';

        if (!formData?.atc_brand_id) return this.ns.showError('Please select brand name.');
        if (!formData?.atc_model_id) return this.ns.showError('Please select model name.');
        if (!formData?.atc_user_id) {
            this.localCartService.addProduct({
                atc_product_id: formData.atc_product_id,
                atc_model_id: formData.atc_model_id,
                atc_brand_id: formData.atc_brand_id,
                atc_color_str: formData.atc_color_str
            })

            this.ns.showSuccess(this.cs.addToCart.success);
            this.eventCenterS.loadAddToCard.next(true);
            this.cd.detectChanges();
            return
        }

        try {
            this.addingToCart = true;
            let res = await this.addToCartService.post(formData);
            if (res) {
                this.ns.showSuccess(this.cs.addToCart.success);
                this.eventCenterS.loadAddToCard.next(true);
            }
        } catch (e: any) {
            this.ns.showErrorFromResponse(e.error || e, 'Unable to add to card product.');
        } finally {
            this.addingToCart = false;
        }
        this.cd.detectChanges();
    }

    async addWishlistProduct() {
        if (this.isWishListProduct) {
            let query = <IQueryFormat>{
                find: <IWishlist_P>{
                    active: true,
                    wis_user_id: this.authService.gUser._id,
                    wis_product_id: <any>this.productId,
                    wis_model_id: <any>this.modelId,
                    wis_brand_id: <any>this.brandId,
                    // wis_color_str: this.selectedColorName
                },
            };
            try {
                this.loading.form = true;
                let res = await this.wishlistService.removeByQuery(query);
                if (res) {
                    this.ns.showSuccess(this.cs.wishlist.remove);
                    await this.getWishlistProduct();
                    this.eventCenterS.loadAddWishlist.next(true);
                }
                this.loading.form = false;
            } catch (e: any) {
                this.loading.form = false;
                this.ns.showErrorFromResponse(e.error || e, 'Unable to remove wishlist product.');
            }
        } else {
            const formData: IWishlist = <any>{};
            formData.active = true;
            formData.createdAt = new Date();
            formData.wis_product_id = <any>this.productId;
            formData.wis_user_id = <any>this.authService.gUser?._id;
            formData.wis_model_id = <any>this.modelId || '';
            formData.wis_brand_id = <any>this.brandId || '';
            // formData.wis_color_str = this.selectedColorName;

            if (!formData?.wis_brand_id) return this.ns.showError('Please select brand name.');
            if (!formData?.wis_model_id) return this.ns.showError('Please select model name.');
            if (!formData?.wis_user_id) return this.eventCenterS.shoLoginDialog.next(true);

            try {
                this.loading.form = true;
                let res = await this.wishlistService.post(formData);
                if (res) {
                    this.ns.showSuccess(this.cs.wishlist.success);
                    await this.getWishlistProduct();
                    this.eventCenterS.loadAddWishlist.next(true);
                }
                this.loading.form = false;
            } catch (e: any) {
                this.loading.form = false;
                this.ns.showErrorFromResponse(e.error || e, 'Unable to add wishlist product.');
            }
        }
        this.cd.detectChanges();
    }

    async onBrandChange() {
        await this.loadModels();
        // a model from the previous brand may not exist under the new brand
        if (this.modelId && !this.modelList.some((m: any) => m._id === this.modelId)) {
            this.modelId = '';
        }
        await this.evaluateSelection();
    }

    async onModelChange(event: any) {
        await this.getWishlistProduct();
        await this.evaluateSelection();
    }

    /**
     * Validates the selected brand + model against the current design:
     *  - match found  → navigate to that variant (page refreshes)
     *  - no match     → block & show the "no design available" message
     *  - incomplete   → nothing to validate yet
     */
    async evaluateSelection() {
        this.noDesignForModel = false;

        if (this.brandId && this.modelId) {
            const modelName = this.modelList.find((m: any) => m._id === this.modelId)?.swm_name_str || '';
            this.selectedBrandModelService.set({ brandId: this.brandId, modelId: this.modelId, modelName });
            const navigated = await this.findProduct();
            if (navigated) return; // navigation reloads everything, incl. the related list
            // valid combo, but this exact design isn't available for it
            this.noDesignForModel = true;
        }

        // always refresh "You May Also Like" for the current selection
        await this.loadProductsRandom();
        this.cd.detectChanges();
    }

    /** Add-to-Cart is only valid when the selection matches the loaded product. */
    get canAddToCart(): boolean {
        return !!this.product?._id
            && this.brandId === this.product?.pro_brand_id?._id
            && this.modelId === this.product?.pro_model_id?._id;
    }

    async getWishlistProduct() {
        this.isWishListProduct = false;
        if (!this.authService.gUser?._id) return;
        this.loading.form = true;
        let query = <IQueryFormat>{
            find: <IWishlist_P>{
                active: true,
                wis_user_id: this.authService.gUser._id,
                wis_product_id: <any>this.productId,
                wis_model_id: <any>this.modelId,
                wis_brand_id: <any>this.brandId,
                wis_color_str: this.selectedColorName
            },
            select: <IWishlist_S>{
                createdAt: 1,
                wis_color_str: 1,
                wis_brand_id: 1,
                wis_model_id: 1,
                wis_product_id: 1,
            },
            sort: <IWishlist_S>{ createdAt: -1 }
        };
        let resp = await this.wishlistService.query(query);
        if (resp && resp.length) this.isWishListProduct = true;
        this.loading.form = false;
        this.cd.detectChanges();
    }

    async loadProductsRandom() {
        this.productsYouMayAlsoLike = [];
        this.productsYouMayAlsoLikeGroups = [];
        this.loading.form = true;
        let query = <IQueryFormat>{
            find: <IProducts_P>{
                active: true,
                pro_brand_id: <any>this.brandId,
                pro_model_id: <any>this.modelId,
            },
            select: <IProducts_S>{
                pro_name_str: 1,
                pro_price_num: 1,
                pro_sale_num: 1,
                pro_discount_price_num: 1,
                // pro_images_color_arr: 1,
                pro_category_id: 1,
                pro_percentage_off_price_num: 1,
                pro_images_arr: 1
            },
            deep: [ {
                s_key: "pro_category_id",
                t_instance: environment.INS,
                t_db: environment.DB,
                t_col: ECollection.SW_CATEGORIES,
                t_key: "_id",
                select: <ICategories_S>{ cat_name_str: 1, cat_sub_category_id: 1, cat_main_category_id: 1 }
            } ],
            sort: <IProducts_S>{ pro_name_str: 1 }
        };
        let resp = await this.productsService.query(query);
        if (resp && resp.length) {
            let productReviews = await this.loadProductsReviewRandom(_.map(resp, "_id"));
            let groupByProductReviews = _.groupBy(productReviews, 'swr_product_id');
            for (let item of resp) {
                if (item.pro_images_arr && item.pro_images_arr.length) {
                    const colorArr = item.pro_images_arr;

                    // const uploadPath = colorArr?.[0]?.pro_template_arr?.[0]?.uploadPath;
                    // if (uploadPath) item.fileUrl = `${this.fileUrl}${uploadPath}`;
                    //
                    // const uploadPath1 = colorArr?.[0]?.pro_template_arr?.[1]?.uploadPath;
                    // if (uploadPath1) item.fileUrl1 = `${this.fileUrl}${uploadPath1}`;
                    const uploadPath = colorArr[0]?.uploadPath;
                    if (uploadPath) item.fileUrl = `${ this.fileUrl }${ uploadPath }`;

                    const uploadPath1 = colorArr[1]?.uploadPath;
                    if (uploadPath1) item.fileUrl1 = `${ this.fileUrl }${ uploadPath1 }`;
                }
                let ratingSum = _.sumBy(groupByProductReviews[item._id], (item: any) => Number(item.swr_rating_str));
                let ratingCount = Math.floor(ratingSum / groupByProductReviews[item._id]?.length);
                item.reviewsRatings = Array.from({ length: ratingCount }, (_, i) => i + 1);
            }
            resp = resp.filter((e: any) => e._id !== this.productId);
        }
        this.productsYouMayAlsoLike = resp;

        // Group related products into visible category sections, ordered A→Z
        const groups = _.groupBy(resp || [], (p: any) => p?.pro_category_id?._id || p?.pro_category_id?.cat_name_str || 'other');
        this.productsYouMayAlsoLikeGroups = Object.keys(groups)
            .map((catId) => ({
                categoryId: catId,
                category: groups[catId]?.[0]?.pro_category_id?.cat_name_str || 'Other',
                products: _.sortBy(groups[catId], (p: any) => (p?.pro_name_str || '').toLowerCase())
            }))
            .sort((a, b) => a.category.localeCompare(b.category));

        // default the active tab to the first category (alphabetically)
        this.selectedAlsoLikeCategoryId = this.productsYouMayAlsoLikeGroups[0]?.categoryId || '';

        this.loading.form = false;
        this.cd.detectChanges();
    }

    selectAlsoLikeCategory(categoryId: string) {
        this.selectedAlsoLikeCategoryId = categoryId;
    }

    get selectedAlsoLikeProducts(): IProducts[] {
        const group = this.productsYouMayAlsoLikeGroups.find(g => g.categoryId === this.selectedAlsoLikeCategoryId);
        return group ? group.products : [];
    }

    async loadProductsReviewRandom(productId: string[]) {
        this.loading.form = true;
        let query = <IQueryFormat>{
            find: <IReviews_P>{
                active: true,
                swr_product_id: <any>{ $in: productId }
            },
            select: <IReviews_S>{
                swr_product_id: 1,
                swr_rating_str: 1
            },
            sort: <IReviews_S>{ createdAt: -1 }
        };
        let resp = await this.reviewsService.query(query);
        this.loading.form = false;
        this.cd.detectChanges();
        return resp;
    }

    openDetailsPage(product: IProducts) {
        this.router.navigate([ '/phone-case-details' ], {
            queryParams: { product: product._id }
        });
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    productCaseSlider() {
        if (typeof $ !== 'undefined' && $('#owl-carousel').length) {
            this.owlCarousel = $('#owl-carousel').owlCarousel({
                items: 1,
                loop: true,
                margin: 0,
                autoplay: false,
                slideTransition: 'linear',
                autoplayTimeout: 3000,
                autoplaySpeed: 1000,
                dots: false,
                nav: true,
                autoplayHoverPause: false,
                responsive: {
                    0: { items: 1 },
                    600: { items: 1 },
                    1030: { items: 1 },
                    1130: { items: 1 },
                    1280: { items: 1 },
                    1400: { items: 1 },
                    1700: { items: 1 },
                    1920: { items: 1 }
                }
            });

            // Listen to slide change events
            this.owlCarousel.on('changed.owl.carousel', (event: any) => {
                this.currentSlideIndex = event.item.index;
            });
        }
    }

    destroyCarousel() {
        if (this.owlCarousel) {
            this.owlCarousel.trigger('destroy.owl.carousel');
            this.owlCarousel = null;
        }
    }

    goToSlide(index: number) {
        if (this.owlCarousel) {
            this.owlCarousel.trigger('to.owl.carousel', [ index, 300 ]);
            this.currentSlideIndex = index;
        }
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
